
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DatabaseInterface, DatabaseRepositoryInterface } from '@/services/Database/interfaces';
import { DataTableHeader } from 'vuetify';
import DeleteDatabaseDialog from '@/components/dialogs/databases/DeleteDatabaseDialog.vue';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    DeleteDatabaseDialog,
  },
  inject: [
    'databaseRepository',
    'serverRepository',
  ],
})
export default class ViewDatabaseDialog extends Vue {
  @Prop() private readonly databaseId!: number;

  private databaseRepository!: DatabaseRepositoryInterface;
  private serverRepository!: ServerRepositoryInterface;

  private database!: DatabaseInterface;
  private servers: ServerInterface[] = [];
  private visible: boolean = true;
  private loading: boolean = true;

  private deleteDatabaseDialog: string = '';
  private deleteDatabaseForDialog: DatabaseInterface | false = false;

  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Username', value: 'username' },
    { text: 'Status', value: 'status' },
  ];

  private statuses: string[] = ['CREATING', 'CREATED', 'ERROR', 'ACTIVE', 'DISABLED'];


  public async created(): Promise<void> {
    try {
      this.database = await this.databaseRepository.getDatabaseById(this.databaseId);
      this.servers = await this.serverRepository.getAllServers();
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }

  private deleteDatabase(): void {
    this.deleteDatabaseDialog = 'delete-database-dialog';
    this.deleteDatabaseForDialog = this.database;
  }

  private filterDatabases(): void {
    this.visible = false;
    this.$emit('database-deleted', this.database);
    this.$emit('close');
  }

  private close(): void {
    this.visible = false;
    this.$emit('close');
  }

  private getServerName(serverId: string): string {
    const server = this.servers.find((s) => s._id === serverId);
    if (!server) {
      return '';
    }

    return server.hostname;
  }

  private async deleteLog(id: number): Promise<void> {
    try {
      await this.databaseRepository.deleteDatabaseLog(id);
      this.$successDialog.show('Log deleted successfully');
      this.database.logs = this.database.logs.filter((log) => log.id !== id);
      this.$forceUpdate();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }
}
